@switch (question?.questionSubType) { @case (questionSubType.RATING_SCALE) {
<div class="rating-scale">
  <!-- Labels Row -->
  <div
    class="labels-row"
    [style.width]=" viewMode === 'mobile' ? toNumber(question?.questionSpecificOptions?.scaleCount) * 29 + 'px' : toNumber(question?.questionSpecificOptions?.scaleCount) * 50 + 'px'"
  >
    @for (label of question?.questionSpecificOptions?.labels; track label) {

    <span class="rating-label text-secondary-500 text-xs text-capitalize">
      {{ label?.text }}
    </span>
    }
  </div>

  <!-- Buttons Row -->
  <div class="buttons-row"
  [class.mobile-view]="viewMode === 'mobile'">
    @for (i of getScaleArray(toNumber(question?.questionSpecificOptions?.scaleCount)); track i) {
    <button
      type="button"
      class="rating-icon p-0"
      [class.text-primary]="selectedRating !== null && selectedRating >= i"
      (click)="selectRating(i, $event)"
      [class.mobile-view]="viewMode === 'mobile'"
    >
      <span class="rating-icon-inner" [class.mobile-view]="viewMode === 'mobile'">
        @switch (question?.questionSpecificOptions?.scaleType) {
          @case (ratingScaleSubType.STAR) {
            <i class="bi bi-star-fill" [class.fa-solid]="selectedRating !== null && selectedRating >= i" [class.fa-regular]="selectedRating === null || selectedRating < i" aria-hidden="true"></i>
          }
          @case (ratingScaleSubType.HEART) {
            <i class="bi bi-suit-heart-fill" [class.fa-solid]="selectedRating !== null && selectedRating >= i" [class.fa-regular]="selectedRating === null || selectedRating < i" aria-hidden="true"></i>
          }
          @case (ratingScaleSubType.THUMBS_UP) {
            <i class="bi bi-hand-thumbs-up-fill" [class.fa-solid]="selectedRating !== null && selectedRating >= i" [class.fa-regular]="selectedRating === null || selectedRating < i" aria-hidden="true"></i>
          }
          @case (ratingScaleSubType.THUMBS_DOWN) {
            <i class="bi bi-hand-thumbs-down-fill" [class.fa-solid]="selectedRating !== null && selectedRating >= i" [class.fa-regular]="selectedRating === null || selectedRating < i" aria-hidden="true"></i>
          }
          @case (ratingScaleSubType.SMILE) {
            <i class="bi bi-emoji-smile-fill" [class.fa-solid]="selectedRating !== null && selectedRating >= i" [class.fa-regular]="selectedRating === null || selectedRating < i" aria-hidden="true"></i>
          }
          @case (ratingScaleSubType.SAD) {
            <i class="bi bi-emoji-frown-fill" [class.fa-solid]="selectedRating !== null && selectedRating >= i" [class.fa-regular]="selectedRating === null || selectedRating < i" aria-hidden="true"></i>
          }
          @case (ratingScaleSubType.ANGRY) {
            <i class="bi bi-emoji-angry-fill" [class.fa-solid]="selectedRating !== null && selectedRating >= i" [class.fa-regular]="selectedRating === null || selectedRating < i" aria-hidden="true"></i>
          }
          @case (ratingScaleSubType.EMOJI) {
            <i class="fa-face-grin-stars" [class.fa-solid]="selectedRating !== null && selectedRating >= i" [class.fa-regular]="selectedRating === null || selectedRating < i" aria-hidden="true"></i>
          }
          @case (ratingScaleSubType.NUMBER) {
            <span class="rating-scale-number fw-semibold">{{ i }}</span>
          }
          @default {
            <i class="fa-circle fa-regular" aria-hidden="true"></i>
          }
        }
      </span>
    </button>
    }
  </div>
</div>
} 
@case (questionSubType.OPINION_SCALE) {
<div class="opinion-scale">
  <div
    class="labels-row"
    [style.width]=" viewMode === 'mobile' ? toNumber(question?.questionSpecificOptions?.scaleCount) * 29 + 'px' : toNumber(question?.questionSpecificOptions?.scaleCount) * 47 + 'px'"
  >
    @for (label of question?.questionSpecificOptions?.labels; track label) {
    <span class="rating-label text-secondary-500 text-xs text-capitalize">
      {{ label?.text }}
    </span>
    }
  </div>
  <div class="opinion-scale-buttons" 
  [class.mobile-view]="viewMode === 'mobile'">
    @for (i of getScaleArray(toNumber(question?.questionSpecificOptions?.scaleCount)); track i) {
    <button
      type="button"
     
      [class.mobile-view]="viewMode === 'mobile'"
      [class.text-primary]="selectedRating !== null && selectedRating >= i"
      (click)="selectRating(i, $event)"
    >
      {{ i }}
    </button>
    }
  </div>
</div>
} @default {
<p class="text-muted">Unknown question type</p>
} }
